import { Button, Drawer, Flex } from 'antd';
import { useEffect, useState } from 'react';
import { selectMachines } from '../../../../slices/machines';
import { useTranslation } from 'react-i18next';
import MachineCheckbox from '../machineCheckbox';
import { useSelector } from 'react-redux';
import { selectLinkedMachines } from '../../../../slices/templates';

export interface MachineDrawerProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (machines: string[]) => void;
}

const MachineDrawer = ({ open, onClose, onConfirm }: MachineDrawerProps) => {
  const { t } = useTranslation();
  const [selectedMachines, setSelectedMachines] = useState<string[]>([]);

  const machines = useSelector(selectMachines);
  const linkedMachines = useSelector(selectLinkedMachines);

  const handleCheckChange = (checked: boolean, id: string) => {
    const nextState = checked
      ? [...selectedMachines, id]
      : selectedMachines.filter((m) => m !== id);
    setSelectedMachines(nextState);
  };

  const handleClose = () => {
    setSelectedMachines([]);
    onClose();
  };

  useEffect(() => {
    if (open) {
      setSelectedMachines(linkedMachines?.map((i) => i.machineID) || []);
    }
  }, [open]);

  return (
    <Drawer
      title={t('link_machines')}
      closable={false}
      onClose={onClose}
      open={open}
      width={800}
      footer={
        <Flex justify="flex-end" gap={16}>
          <Button type="primary" ghost onClick={onClose}>
            {t('cancel')}
          </Button>
          <Button type="primary" onClick={() => onConfirm(selectedMachines)}>
            {t('confirm')}
          </Button>
        </Flex>
      }
    >
      <Flex vertical gap={8}>
        {machines.map((m) => (
          <MachineCheckbox
            key={m.machineID}
            machine={m}
            checkable
            checked={selectedMachines.includes(m.machineID)}
            onCheckChange={(checked) => handleCheckChange(checked, m.machineID)}
          />
        ))}
      </Flex>
    </Drawer>
  );
};

export default MachineDrawer;
